let Vue = require('vue');
let template = require('templates/ui-pagination.html');
let {range} = require('sci/helpers/prelude');
let urlparse = require('url-parse');
let qs = require('qs');

let PhotoSwipe = require('photoswipe');
let PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');

let pswpTemplate = require('templates/components/pswp-element.html');

Vue.directive('property-gallery', {
    params: ['property'],
    bind() {
        let pswpElement = null;
        if ($('body').find('.pswp').length) {
            pswpElement = $('body').find('.pswp').get(0);
        } else {
            $('body').append(pswpTemplate);
            pswpElement = $('body').find('.pswp').get(0);
        }

        let self = this;

        if (self.params.property.photos.length < 1 && self.params.property.videos.length < 1) {
            return;
        }
        console.log(self.params.property.photos, self.params.property)
        $(this.el).click(function () {
            var items = self.params.property.photos.map((photo) => {
                let url = photo.url;

                if (url.indexOf('v8-images')) {
                    url += '?size=1920x1080'
                }

                return {
                    src: url,
                    w: photo.width ? photo.width : 1920,
                    h: photo.height ? photo.height :  1080,
                    title: photo.description || photo.name
                };
            });
            
            items = items.concat(self.params.property.videos.map((video) => {
                let url = urlparse(video.url);
                let querystring = qs.parse(url.query.replace(/^\?/, ''));
                var code = querystring.v;
                return {
                    html: `<iframe src="https://youtube.com.br/embed/${code}"></iframe>`
                }
            }));

            var options = {
                // history & focus options are disabled on CodePen
                history: false,
                arrowKeys: true,
                closeOnScroll: false,
                shareEl: false,
                counterEl: false
            };

            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();

            return false;
        });
    },
    update() {

    },
    unbind() {

    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui-property-gallery.js